import Welcome from './Welcome';

export default Welcome;


// WEBPACK FOOTER //
// /src/components/intro/pages/welcome/index.js